import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// IBM Plex Sans and Mono, self-hosted via @fontsource. 400/500/600 sans for
// body and headings, 400/500 mono for clause quotes and identifiers.
//
// The latin subset only. The default entry point declares a face per subset —
// latin, latin-ext, cyrillic, cyrillic-ext, greek, vietnamese — for each of
// the five weights, and ships every file. Nothing in this application, in the
// taxonomy, or in a federal M&V plan is written in any of the other five, so
// they were 470 kB of deployed bytes no browser would ever request. The
// section sign, the en dash, the typographic quotes and the degree sign are
// all inside latin.
import '@fontsource/ibm-plex-sans/latin-400.css';
import '@fontsource/ibm-plex-sans/latin-500.css';
import '@fontsource/ibm-plex-sans/latin-600.css';
import '@fontsource/ibm-plex-mono/latin-400.css';
import '@fontsource/ibm-plex-mono/latin-500.css';

import './styles/global.css';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
